import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CreateAssetDto } from '@thehubz/client/data-access-api';
import { AssetAnnotatorService } from '../../services/asset-annotator.service';

@Component({
  selector: 'thehubz-image-editor',
  templateUrl: './image-editor.component.html',
  styleUrls: ['./image-editor.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule],
})
export class ImageEditorComponent {
  @Input() fileUrl = '';
  private sceneWidth = 0;
  private sceneHeight = 0;
  private containerWidth = 0;
  private containerHeight = 0;
  private assetTypes = CreateAssetDto.AssetTypeEnum;
  public zoom = 1;
  public maxZoom = 3;
  public zoomStep = 0.25;
  @Output() openFullScreenClick = new EventEmitter<void>();

  constructor(private anService: AssetAnnotatorService) {}

  imgLoaded(_e: any) {
    this.sceneHeight = document.getElementById('asset-img')?.clientHeight || 0;
    this.sceneWidth = document.getElementById('asset-img')?.clientWidth || 0;

    this.anService.initKonvaStage('konva-holder', this.sceneWidth, this.sceneHeight, this.assetTypes.Image);

    setTimeout(() => {
      const annotationWindow = document.getElementById('annotation-window');
      this.containerWidth = annotationWindow?.clientWidth || 0;
      this.containerHeight = annotationWindow?.clientHeight || 0;
      if (annotationWindow) {
        //fixing the frame so that overflow works and this is necessary for PDF asset
        annotationWindow.style.width = annotationWindow.clientWidth + 12 + 'px';
      }
    }, 500);
  }

  draw(tool: string) {
    const scrollLeft = document.getElementById('annotation-window')?.scrollLeft || 0;
    const scrollTop = document.getElementById('annotation-window')?.scrollTop || 0;
    this.anService.drawTool(tool, this.assetTypes.Image, scrollLeft, scrollTop);
  }

  zoomImage(direction: number) {
    this.zoomAsset(direction);

    const imgContainer = document.getElementById('img-container');
    let newHeight = 1;
    let newWidth = 1;
    if (imgContainer) {
      newWidth = this.sceneWidth + this.sceneWidth * (this.zoom - 1);
      newHeight = this.sceneHeight + this.sceneHeight * (this.zoom - 1);

      //below condition for width is a special guard for portrait images
      if (direction == 1) {
        if (newWidth > this.containerWidth) imgContainer.style.width = newWidth + 'px';
      } else {
        if (newWidth < this.containerWidth) imgContainer.style.width = this.containerWidth + 'px';
        else imgContainer.style.width = newWidth + 'px';
      }
      imgContainer.style.height = newHeight + 'px';
    }

    setTimeout(() => {
      this.adjustKonvaCanvasToImage();
    }, 0);
  }

  adjustKonvaCanvasToImage() {
    const img = document.getElementById('asset-img');
    this.anService.resizeKovnvaCanvas(img?.clientWidth || 1, img?.clientHeight || 1, true);

    const imgContainer = img?.parentElement;
    const konvaContainer = document.querySelector('.konvajs-content') as HTMLElement;

    if (imgContainer && konvaContainer && imgContainer.clientWidth && imgContainer.clientHeight) {
      konvaContainer.style.width = String(imgContainer.clientWidth);
      konvaContainer.style.height = String(imgContainer.clientHeight);
    }
  }

  zoomAsset(direction: number) {
    if (direction == 1 && this.zoom < this.maxZoom) this.zoom += this.zoomStep;
    if (direction == -1 && this.zoom > 1) this.zoom -= this.zoomStep;
  }

  resetZoom() {
    this.zoom = 1.25;
    this.zoomImage(-1);
  }

  scrollHandler(e: any) {
    document.getElementById('konva-holder')?.scrollTo({ top: e.target.scrollTop, left: e.target.scrollLeft });
  }

  openAssetFullscreen() {
    this.openFullScreenClick.emit();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustKonvaCanvasToImage();
  }
}
